import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 支払方法一覧
export async function getProductPaymentMethods(id: string) {
  try {
    const path = "productPaymentMethods";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// 支払方法編集
export async function putProductPaymentMethod(editData: EditDataDifine) {
  try {
    const path = "productPaymentMethod";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}
// 支払方法登録
export async function postProductPaymentMethod(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "productPaymentMethod";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
